/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoIconDTO } from './geoIconDTO';


export interface GeoStatusDisplayDTO { 
    cellType?: string;
    value?: GeoStatusDisplayDTO.ValueEnum;
    displayLabel?: string;
    pillVariant?: string;
    icon?: GeoIconDTO;
}
export namespace GeoStatusDisplayDTO {
    export type ValueEnum = 'In Progress' | 'Results Pending' | 'Scheduled' | 'Action Needed' | 'Pending Launch' | 'Draft' | 'Finished' | 'None';
    export const ValueEnum = {
        InProgress: 'In Progress' as ValueEnum,
        ResultsPending: 'Results Pending' as ValueEnum,
        Scheduled: 'Scheduled' as ValueEnum,
        ActionNeeded: 'Action Needed' as ValueEnum,
        PendingLaunch: 'Pending Launch' as ValueEnum,
        Draft: 'Draft' as ValueEnum,
        Finished: 'Finished' as ValueEnum,
        None: 'None' as ValueEnum
    };
}


